import { AgentThreadVo, api } from "@/api";

interface FetchThreadsOptions {
  limit?: number;
  offset?: number;
}

export async function fetchUserThreads(options: FetchThreadsOptions = {}) {
  const { limit, offset } = options;
  const res = await api.threads.listThreads({ limit, offset });
  const list = res.data?.list || [];

  // Only return threads where the current user is the owner
  return list.filter((thread: AgentThreadVo) => thread.owner);
}
